import ReactSlider from 'react-slider';
import { Thumb } from './styled';
import type { TimeSeriesItem } from '../../../../hooks/useCompanyTimeSeries';
import { Box, Grid, Text } from '@simplywallst/ui-core';
import { MiniChart } from '@/components/MiniChart/MiniChart';
import { getMiniChartEntries, getMiniChartKeys } from '../Sankey/utils/utils';

type Props = {
  marks: [number, string][];
  defaultValue: number;
  onChange: (value: number) => void;
  timeSeries?: TimeSeriesItem[] | null;
};

export const Slider = ({
  marks,
  defaultValue,
  timeSeries,
  onChange,
}: Props) => {
  const markValues = marks.map((n) => n[0]);
  const markMin = Math.min(...markValues);
  const markMax = Math.max(...markValues);
  const totalMarks = markValues.length;
  const entries = getMiniChartEntries(timeSeries);
  const keys = getMiniChartKeys(timeSeries);

  if (totalMarks === 0) {
    return null;
  }

  return (
    <Box
      userSelect="none"
      position="relative"
      height="40px"
      marginBottomMd="x2"
    >
      <ReactSlider
        min={markMin}
        max={markMax}
        defaultValue={defaultValue}
        onChange={(value) => onChange(value)}
        renderThumb={(props) => (
          // @ts-expect-error - FIXME
          <Thumb {...props} totalMarks={totalMarks}>
            <Text typography="xSmall"> </Text>
          </Thumb>
        )}
        // @ts-expect-error - FIXME
        renderTrack={(props, state) => {
          return (
            state.index === 0 && (
              <Grid
                {...props}
                borderRadius="x1"
                backgroundColor="spaceGray"
                templateColumns={`repeat(${marks.length}, 1fr)`}
                alignItems="center"
                justifyItems="center"
                // @ts-expect-error - FIXME
                $width="100%"
                $height="40px"
              >
                {entries && keys && (
                  <MiniChart entries={entries} keys={keys} period="10Y" />
                )}
                {marks.map((n, i) => {
                  const value = n[0];
                  const label = n[1];
                  const showLabel = i % 2 === 0 || state.value === value;
                  if (isNaN(value)) return null;
                  return (
                    <Text key={i} typography="tiny">
                      {showLabel && label}
                    </Text>
                  );
                })}
              </Grid>
            )
          );
        }}
      />
    </Box>
  );
};
